import './SelectMenu.scss'
import { useContext } from 'react'
import { ThemeContext } from '../../context'


import period from './periodes.json'
import formation from './formation.json'
import organisme from './organismes.json'
// origine.
// https://data.enseignementsup-recherche.gouv.fr/explore/dataset/curiexplore-pays/table/?flg=fr&disjunctive.iso3&sort=name_fr&location=2,28.95894,1.5&basemap=e69ab1
import origin from './curiexplore-pays.json'


export default function Select_Menu({periodSelected,setPeriodSelected,paysOrigine,setPaysOrigine,formationSelected,setFormationSelected,organismeSelected,setOrganismeSelected})
{
    const {theme} = useContext(ThemeContext)
    //periode
    //    const [periodSelected, setPeriodSelected] = useState("")

    //gestion des pays
    //    const [paysOrigine, setPaysOrigine] = useState("")

        const pays = []
        origin.map((select) => pays.push(select.name_fr))
        pays.sort()

    //gestion formation
    //const [formationSelected, setFormationSelected] = useState("")
        // **********************************************************************
        // *** Génération de la liste des formations pour le pays selectionné ***
        // **********************************************************************
        let selectFormation = [];
        if (paysOrigine === "")
            {
                selectFormation = formation
            }
        else
            {
                for (let i=0 ; i<formation.length ; i++)
                {
                    if (formation[i].origine === paysOrigine)
                    {selectFormation.push(formation[i])} 
                }
            }
        
        // **********************************************************************
    //gestion organisme
    //const [organismeSelected, setOrganismeSelected] = useState("")

    // **************************************************************************

    return(
        <div id="select_menu" className={`menu_${theme}`}>
            <label htmlFor="period_select">Période:</label>
            <select 
                name="period" 
                id="period_select"
                value={periodSelected}
                onChange={(change) => {setPeriodSelected(change.target.value);}}
            >
                <option value="">-- Toutes --</option>
                {
                    period.map((element) => (
                            <option 
                                key={element.SOUS_ETAGE} 
                                value={element.SOUS_ETAGE} 
                                style= {{backgroundColor : `#${element.COULEUR}`}}
                            >
                                {element.SOUS_ETAGE}
                            </option>
                        ))
                }
            </select>

            <label htmlFor="origin_select">Origine:</label>
            <select 
                name="origin" 
                id="origin_select"
                value={paysOrigine}
                onChange={(change) => {setPaysOrigine(change.target.value);}}
            >
                <option value="">-- Toutes --</option>
                {
                    pays.map((element) => 
                        (
                            <option 
                                value={element}
                                key={element}
                            >
                                {element}
                            </option>
                        )
                )}
            </select>

            <label htmlFor="formation_select">Formation:</label>
            <select 
                name="formation" 
                id="formation_select"
                value={formationSelected}
                onChange={(change) => {setFormationSelected(change.target.value)}}
            >
                <option value="">-- Toutes --</option>
                {
                    selectFormation.map((element) => 
                        (
                            <option 
                                value={element.nom}
                                key={element.nom}
                            >
                                {element.nom}
                            </option>
                        )
                )}
            </select>



            <label htmlFor="organisme_select">Organismes:</label>
            <select 
                name="organisme" 
                id="organisme_select"
                value = {organismeSelected}
                onChange={(change) => {setOrganismeSelected(change.target.value)}}
            >
                <option value="">-- Tous --</option>
                {
                    organisme.map((element) => 
                        (
                            <option 
                                value={element.organisme}
                                key={element.organisme}
                            >
                                {element.organisme}
                            </option>
                        )
                )}
            </select>


        </div>
    )
}